import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Home.css';

function Home() {
  const [gurus, setGurus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEmeraldModal, setShowEmeraldModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchGurus();
  }, []);

  useEffect(() => {
    // Auto-redirect to Roger Scott dashboard
    if (!loading && gurus.length > 0) {
      const rogerScott = gurus.find(g => g.slug === 'rogerscott');
      if (rogerScott) {
        navigate('/gurus/rogerscott');
      }
    }
  }, [loading, gurus, navigate]);

  const fetchGurus = async () => {
    try {
      const response = await api.get('/gurus');
      setGurus(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to load gurus');
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="home">
      <div className="hero">
        <h1 className="hero-title">ALL-ACCESS</h1>
        <p className="hero-subtitle">
          Your unified trading dashboard for all guru trade alerts
        </p>
      </div>

      <div className="guru-grid">
        {/* EMERALD VIP Card */}
        <div className="guru-card emerald-card emerald-card-locked" onClick={() => setShowEmeraldModal(true)}>
          <div className="emerald-badge">VIP</div>
          <div className="emerald-lock-badge">🔒 UPGRADE</div>
          <div className="emerald-avatars">
            {gurus && gurus.slice(0, 9).map((guru, index) => (
              guru.avatar_url && (
                <div key={guru.id} className="emerald-mini-avatar" style={{ zIndex: 9 - index }}>
                  <img src={guru.avatar_url} alt={guru.name} />
                </div>
              )
            ))}
          </div>
          <h3 className="guru-name emerald-name">EMERALD</h3>
          <p className="emerald-subtitle">All Gurus Combined</p>
        </div>

        {/* Guru Cards */}
        {gurus && gurus.length > 0 ? (
          gurus.map((guru) => {
            const isLocked = guru.slug !== 'rogerscott';

            if (isLocked) {
              return (
                <div
                  key={guru.id}
                  className="guru-card guru-card-locked"
                >
                  <div className="locked-icon">🔒</div>
                  {guru.avatar_url && (
                    <div className="guru-card-avatar">
                      <img src={guru.avatar_url} alt={guru.name} />
                    </div>
                  )}
                  <h3 className="guru-name">{guru.name}</h3>
                  <p className="locked-text">No Access</p>
                </div>
              );
            }

            return (
              <Link
                key={guru.id}
                to={`/gurus/${guru.slug}`}
                className="guru-card guru-card-unlocked"
              >
                <div className="unlocked-badge">✓ ACCESS</div>
                {guru.avatar_url && (
                  <div className="guru-card-avatar">
                    <img src={guru.avatar_url} alt={guru.name} />
                  </div>
                )}
                <h3 className="guru-name">{guru.name}</h3>
              </Link>
            );
          })
        ) : (
          <p className="no-gurus">No gurus available yet</p>
        )}
      </div>

      {/* Emerald Upgrade Modal */}
      {showEmeraldModal && (
        <div className="modal-overlay" onClick={() => setShowEmeraldModal(false)}>
          <div className="emerald-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowEmeraldModal(false)}>×</button>

            <div className="emerald-modal-header">
              <div className="emerald-modal-icon">💎</div>
              <h2 className="emerald-modal-title">EMERALD ALL-ACCESS</h2>
              <p className="emerald-modal-subtitle">Premium Access to All Gurus</p>
            </div>

            <div className="emerald-modal-content">
              <div className="emerald-features">
                <h3>What's Included:</h3>
                <ul className="emerald-features-list">
                  <li>
                    <span className="feature-icon">✅</span>
                    <span>Access to <strong>ALL {gurus.length} Guru Dashboards</strong></span>
                  </li>
                  <li>
                    <span className="feature-icon">✅</span>
                    <span>Combined trade tracking from <strong>all gurus</strong></span>
                  </li>
                  <li>
                    <span className="feature-icon">✅</span>
                    <span>Unified statistics and performance analytics</span>
                  </li>
                  <li>
                    <span className="feature-icon">✅</span>
                    <span>Real-time alerts from every guru</span>
                  </li>
                  <li>
                    <span className="feature-icon">✅</span>
                    <span>Priority support and updates</span>
                  </li>
                  <li>
                    <span className="feature-icon">✅</span>
                    <span>AI-powered trade explanations</span>
                  </li>
                </ul>
              </div>

              <div className="emerald-gurus-grid">
                <h3>All Gurus Included:</h3>
                <div className="emerald-gurus-list">
                  {gurus.map((guru) => (
                    <div key={guru.id} className="emerald-guru-item">
                      {guru.avatar_url && (
                        <img src={guru.avatar_url} alt={guru.name} className="emerald-guru-avatar" />
                      )}
                      <span className="emerald-guru-name">{guru.name}</span>
                    </div>
                  ))}
                </div>
              </div>

              <button className="emerald-upgrade-btn">
                🔓 Upgrade to EMERALD
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
